import { toJS } from 'mobx';
import { inject, observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import { isEmpty } from 'coreutils-js';

import CommonStatus from 'constants/types/common-status';
import RoleType from 'constants/types/role-type';

import './style.scss';

import {
  Button, Card, Form, FormItem, InputText, notify, PermissionForm, SelectBox, TextArea, useForm
  //@ts-ignore
} from '@microui/react-ui';
import { DetailLayout } from 'components/layouts';

function SettingRole({ store, navigateBack, applicationId, channelId, roleId }: any) {
  const [form] = useForm();
  const [permission, setPermission] = useState([]);

  useEffect(() => {
    store.getData(applicationId, channelId, roleId)
      .then(({ roleInfo, rolePermissions }) => {
        setPermission(rolePermissions);

        if (!isEmpty(roleInfo)) {
          form.setFieldsValue(roleInfo);
        } else {
          form.setFieldsValue({ status: CommonStatus.ACTIVED });
        }
      });
  }, []);

  const onSubmit = (vals) => {
    const dataSave = vals;

    dataSave.permissions = permission.join(';');

    if (roleId) {
      store.roleApi.updateRole(roleId, dataSave)
        .then(() => {
          notify.success('Cập nhật thông tin vai trò thành công');
        });
    } else {
      store.roleApi.createRole({ ...dataSave, applicationId, channelId })
        .then(() => {
          notify.success('Tạo vai trò thành công');
          navigateBack({ applicationId, channelId });
        });
    }
  };

  return (
    <DetailLayout
      buttons={[
        <Button color="primary" type="primary" onClick={form.submit}>
          Hoàn thành
        </Button>
      ]}
      navigateBack={() => navigateBack({ applicationId, channelId })}
    >
      <Form form={form} onFinish={onSubmit}>
        <div className="px-6 py-5 overflow-auto">
          <div className="m-auto grid grid-cols-3 gap-4">
            <Card
              title="Thông tin chức vụ"
              className="col-span-1"
              bodyClassName="p-3.5"
              showCollapse={false}
            >
              <FormItem
                name="name"
                label="Tên"
                required
              >
                <InputText placeholder="Nhập tên" />
              </FormItem>

              <FormItem name="description" label="Mô tả">
                <TextArea className="max-h-[300px] min-h-[100px]" autoResize placeholder="Nhập mô tả" />
              </FormItem>

              <FormItem name="type" label="Loại vai trò" required inputClassName="w-full">
                <SelectBox
                  data={Object.keys(RoleType).map((val) => ({ value: val, label: RoleType[val].label }))}
                  placeholder="Chọn loại vai trò"
                />
              </FormItem>

              <FormItem name="status" label="Trạng thái" required inputClassName="w-full">
                <SelectBox
                  data={Object.keys(CommonStatus).map((val) => ({ value: val, label: CommonStatus[val].label }))}
                  placeholder="Chọn trạng thái"
                />
              </FormItem>
            </Card>

            <Card
              title="Chọn quyền"
              className="col-span-2"
              showCollapse={false}
            >
              <PermissionForm
                data={toJS(store?.permissionsData) ?? []}
                selected={permission}
                styleName="min-height-role"
                className="overflow-auto"
                onChange={setPermission}
              />
            </Card>
          </div>
        </div>
      </Form>
    </DetailLayout>
  );
}

export default inject('store')(observer(SettingRole));
